module.exports = __webpack_public_path__ + "img/auth-bg-1.bdfc0705.svg";